<template>
  <div class="animated fadeIn reg">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters v-model="filterOptions" style="margin-right: 45px" @click="refresh" />
            <DropdownColumns
              :fields="[]"
              class="customize"
              :export-link="exportLink"
              :export-json="exportJson"
            />
          </div>
          <div style="overflow:auto" class="mt-2">
            <b-table
              id="shop-balance-table"
              :busy.sync="isBusy"
              show-empty
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :hover="true"
              :striped="true"
              class="table-wborder"
              v-model="copy"
              :items="provider"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              @row-clicked="rowClicked"
              tbody-tr-class="tr-pointer"
              v-columns-resizable="{afterResize: columnsWidthChanged}"
            >
              <template v-slot:head()="scope">{{ $t(scope.label) }}</template>

              <template v-slot:cell(shop_code)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/shops/${data.value.to}`">{{ data.value.name }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(shop_name)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/shops/${data.value.to}`">{{ data.value.name }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(timestamp)="data">
                <span>{{ mom_unix(data.value).format(tableDateShort) }}</span>
              </template>
              <template v-slot:cell(last_modified)="data">
                <span>{{ mom_unix(data.value).format(tableDateLong) }}</span>
              </template>
              <template v-slot:cell(day_in)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(day_out)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(deposits)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(withdrawals)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(pa)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(cb)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(bba)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(ca)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(cuwa)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(puwa)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(cutn)="data">
                <span v-if="data.value">{{ data.value }}</span>
                <span v-else>0</span>
              </template>
              <template v-slot:cell(putn)="data">
                <span v-if="data.value">{{ data.value }}</span>
                <span v-else>0</span>
              </template>
            </b-table>
          </div>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{(currentPage-1) * perPage + 1}}</span>
                    <span slot="end">{{currentPage * perPage}}</span>
                    <span slot="total">{{totalRows}}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="$root.$emit('bv::refresh::table', 'shop-balance-table')"
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";
import timeFormat from "@/shared/timeFormat";

export default {
  name: "shopBalance",
  mixins: [tableMixin],
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters
  },
  data: function() {
    return {
      tableName: "shopBalance",
      filterOptions: [
        {
          field: "company_id",
          multiple: true,
          placeholder: "Company",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "companies",
          hide_select: true,
          filterOptions: ["tenant_id"],
          options: [],
          selected: [],
          postIgnore: true
        },
        {
          field: "tenant_id",
          multiple: true,
          placeholder: "Tenant",
          trackBy: "eid",
          label: "brand_name",
          translate: false,
          store: "tenants",
          hide_select: true,
          filterOptions: ["shopgroup_id", "sid"],
          options: [],
          originalOptions: [],
          selected: [],
          postIgnore: true,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map(elem => elem.eid);
            const orig = data.list[1].originalOptions;
            if (
              selected.length == 0 &&
              data.list[1].options.length != orig.length
            ) {
              data.list[1].options = orig;
            } else if (selected.length != 0) {
              data.list[1].options = orig.filter(item => {
                if (selected.indexOf(item.ecompany_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          }
        },

        {
          field: "shopgroup_id",
          multiple: true,
          placeholder: "Shop Group",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shopGroups",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          filterOptions: ["sid"],
          postIgnore: true,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map(elem => elem.eid);
            const index = 2;
            const orig = data.list[index].originalOptions;
            if (selected.length == 0) {
              data.list[index].options = orig;
            } else {
              data.list[index].options = orig.filter(item => {
                if (selected.indexOf(item.etenant_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          }
        },
        {
          field: "sid",
          multiple: true,
          placeholder: "Shop",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shops",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          filterOptionsBy: (data, field, fieldValue) => {
            let selectedTenants = [];
            let selectedShopGroups = [];

            if (field == "tenant_id") {
              selectedTenants = fieldValue.map(elem => elem.eid);
            } else {
              selectedTenants = data.list[0].selected.map(elem => elem.eid);
            }
            if (field == "shopgroup_id") {
              selectedShopGroups = fieldValue.map(elem => elem.eshop_ids);
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            } else {
              selectedShopGroups = data.list[2].selected.map(
                elem => elem.eshop_ids
              );
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            }
            const index = 3;
            const orig = data.list[index].originalOptions;

            if (!selectedTenants.length && !selectedShopGroups.length) {
              data.list[index].options = orig;
            } else {
              let tmp = [];

              if (selectedTenants.length) {
                tmp = orig.filter(item => {
                  if (selectedTenants.indexOf(item.etenant_id) > -1) {
                    return true;
                  }
                  return false;
                });
              }

              if (selectedShopGroups.length) {
                if (!selectedTenants.length && !selectedTenants.length) {
                  tmp = orig;
                }
                tmp = tmp.filter(item => {
                  if (selectedShopGroups.indexOf(item.eid) > -1) {
                    return true;
                  }
                  return false;
                });
              }
              data.list[index].options = tmp;
            }
          }
        },
        {
          field: "ts",
          type: "date",
          opens: "right",
          timePicker: false,
          locale: {
            format: timeFormat.datePickerShort, //format of the dates displayed
            firstDay: 1, //ISO first day of week - see moment documentations for details
            showWeekNumbers: true //show week numbers on each row of the calendar
          },
          selected: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day")
          },
          default: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day")
          },
          ranges: {
            Today: [moment().startOf("day"), moment().endOf("day")],
            Yesterday: [
              moment()
                .subtract(1, "days")
                .startOf("day"),
              moment()
                .subtract(1, "days")
                .endOf("day")
            ],
            "This week": [
              moment().startOf("isoWeek"),
              moment().endOf("isoWeek")
            ],
            "Last week": [
              moment()
                .subtract(1, "week")
                .startOf("isoWeek"),
              moment()
                .subtract(1, "week")
                .endOf("isoWeek")
            ],
            "This month": [moment().startOf("month"), moment().endOf("month")],
            "Last month": [
              moment()
                .subtract(1, "month")
                .startOf("month"),
              moment()
                .subtract(1, "month")
                .endOf("month")
            ],
            "This year": [moment().startOf("year"), moment().endOf("year")],
            "Last year": [moment().subtract(1, "year"), moment()]
          }
        }
      ],
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      copy: null,
      addLabel: "",
      selected_products: [],

      balancePreviousDay: 0,
      subtotalIn: 0,
      subtotalOut: 0,
      total: 0
    };
  },
  computed: {
    fields() {
      /*
      "sid":           model.FieldDetails{false, "Int64", "bigint", false, 1, false},
			"ts":            model.FieldDetails{false, "Int64", "bigint", false, 0, false},
			"ca":            model.FieldDetails{false, "Int64", "bigint", false, 0, false},
			"cuwa":          model.FieldDetails{false, "Int64", "bigint", false, 0, false},
			"pa":            model.FieldDetails{false, "Int64", "bigint", false, 0, false},
			"puwa":          model.FieldDetails{false, "Int64", "bigint", false, 0, false},
			"day_in":        model.FieldDetails{false, "Int64", "bigint", false, 0, false},
			"day_out":       model.FieldDetails{false, "Int64", "bigint", false, 0, false},
			"last_modified": model.FieldDetails{false, "Int64", "bigint", false, 0, false},
			"cb":            model.FieldDetails{false, "Int64", "bigint", false, 0, false},
			"deposits":      model.FieldDetails{false, "Int64", "bigint", false, 0, false},
			"withdrawals":   model.FieldDetails{false, "Int64", "bigint", false, 0, false},
			"bba":           model.FieldDetails{false, "Int64", "bigint", false, 0, false},
      */
      const columns = [
        {
          key: "shop_code",
          label: "Code",
          sortable: false,
          ignore: true,
          class: ""
        },
        {
          key: "shop_name",
          label: "Name",
          sortable: false,
          ignore: true,
          class: ""
        },
        {
          key: "day_in",
          label: "Day In",
          sortable: true,
          ignore: true,
          class: "text-right"
        },
        {
          key: "day_out",
          label: "Day Out",
          sortable: true,
          ignore: true,
          class: "text-right"
        },
        {
          key: "deposits",
          label: "Supply",
          sortable: true,
          ignore: true,
          class: "text-right"
        },
        {
          key: "withdrawals",
          label: "Deposits",
          sortable: true,
          ignore: true,
          class: "text-right"
        },
        {
          key: "last_modified",
          label: "Last Modified",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "ca",
          label: "Balance",
          sortable: true,
          ignore: true,
          class: "text-right"
        },
        {
          key: "cuwa",
          label: "U.W. Amount",
          headerTitle: this.$t("Unclaimed Winning Amount"),
          sortable: true,
          ignore: true,
          class: "text-right"
        },
        {
          key: "pa",
          label: "Previous Balance",
          sortable: true,
          ignore: true,
          class: "text-right"
        },
        {
          key: "puwa",
          label: "P.U.W. Amount",
          headerTitle: this.$t("Previous Unclaimed Winning Amount"),
          sortable: true,
          ignore: true,
          class: "text-right"
        },
        {
          key: "cb",
          label: "Current Balance",
          sortable: true,
          ignore: true,
          class: "text-right"
        },
        {
          key: "bba",
          label: "Block Balance",
          sortable: true,
          ignore: true,
          class: "text-right"
        },
        {
          key: "cutn",
          label: "# U. Tickets",
          headerTitle: this.$t("Unclaimed Tickets Number"),
          sortable: true,
          ignore: true,
          class: "text-right"
        },
        {
          key: "putn",
          label: "# P.U. Tickets",
          headerTitle: this.$t("Previous Unclaimed Tickets Number"),
          sortable: true,
          ignore: true,
          class: "text-right"
        }
      ];

      return columns;
    },
    lang() {
      return this.$store.getters["global/defLanguage"];
    },
    exportLink() {
      const apiUrl = this.$store.getters["global/apiUrl"];
      const endpoint = this.$store.getters["shopBalance/endpoint"];

      return `${apiUrl}/${endpoint}?export=xls&lang=${this.lang}`;
    },
    exportJson() {
      const fields = [];
      this.fields.forEach(item => {
        if (
          typeof item.class != "undefined" &&
          item.class.indexOf("d-none") == -1
        ) {
          let key = item.key;
          if (key != "selected") {
            const efields = ["eshop_id"];

            if (efields.indexOf(key) > -1) {
              key = key.substr(1);
            }

            fields.push(key);
          }
        }
      });

      const paginationData = this.buildPagination();

      paginationData.fields = fields;

      return JSON.stringify(paginationData);
    }
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "shop-balance-table");
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = this.buildPagination();
      const shopByID = this.$store.getters["cache/shopByID"];

      Promise.all([
        this.$store.dispatch("cache/fetch", "shops").catch(e => e)
      ]).finally(() => {
        this.$store
          .dispatch("shopBalance/fetch", paginationData)
          .then(resp => {
            this.totalRows = resp.data.total;
            resp.data.rows.forEach((item, index) => {
              if (item.sid) {
                const shop = shopByID(item.sid);
                if (shop) {
                  item.shop_name = {
                    to: item.sid,
                    name: shop.name
                  };
                  item.shop_code = {
                    to: item.sid,
                    name: shop.code
                  };
                } else {
                  item.shop_name = {
                    to: item.sid,
                    name: item.sid
                  };
                  item.shop_code = {
                    to: item.sid,
                    name: item.sid
                  };
                }
              }
            });
            callback(resp.data.rows);
          })
          .catch(err => {
            this.$bvToast.toast(
              this.$t(
                err.details && err.details.length ? err.details[0] : err.message
              ),
              errorConf(this.$t("Error"))
            );
            this.totalRows = 0;
            callback([]);
          })
          .finally(() => {
            loading.close();
          });
      });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    buildPagination() {
      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        paginationData.sortBy = [this.sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach(item => {
        if (item.type != "date" && item.selected.length && !item.postIgnore) {
          exactFields.push(item.field);
          if (item.trackBy) {
            const tmp = [];
            item.selected.forEach(el => {
              tmp.push(el[item.trackBy]);
            });
            exactValues.push(tmp);
          } else {
            exactValues.push(item.selected);
          }
        } else if (item.type == "date") {
          if (item.selected.startDate && item.selected.endDate) {
            paginationData.dateField = item.field;
            paginationData.dateStart = this.specialDate(
              item.selected.startDate,
              true
            );
            paginationData.dateEnd = this.specialDate(
              item.selected.endDate,
              false
            );
          } else {
            paginationData.dateField = item.field;
            paginationData.dateStart = this.specialDate(
              moment().startOf("day"),
              true
            );
            paginationData.dateEnd = this.specialDate(
              moment().endOf("day"),
              false
            );
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      return paginationData;
    },
    rowClicked(item, index, event) {
      this.$router.push(
        "/shop-balance/" +
          item.sid +
          "?startDate=" +
          encodeURIComponent(this.filterOptions[4].selected.startDate) +
          "&endDate=" +
          encodeURIComponent(this.filterOptions[4].selected.endDate)
      );
    },
    redirect() {}
  }
};
</script>

<style lang="scss" scoped>
.reg {
  & /deep/ #cash-register-table tfoot th {
    border: 0 !important;
  }
}
</style>
